var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 202.953,
    height: 28.446,
    viewBox: "0 0 202.953 28.446",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_469",
    "data-name": "Rectangle 469",
    width: 29.865,
    height: 28.446,
    fill: "#ebd000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10187",
    "data-name": "Group 10187",
    transform: "translate(-202.068 -753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "star",
    transform: "translate(202.068 753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2803",
    "data-name": "Group 2803",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10609",
    "data-name": "Path 10609",
    d: "M23.23,28.439a1.444,1.444,0,0,1-.684-.164l-7.634-4-7.636,4a1.5,1.5,0,0,1-2.168-1.59l1.5-8.424L.437,12.275a1.508,1.508,0,0,1-.374-1.5A1.5,1.5,0,0,1,1.28,9.764L9.808,8.522,13.568.843a1.491,1.491,0,0,1,2.686,0l3.807,7.663L28.59,9.75a1.474,1.474,0,0,1,.836,2.513l-6.167,5.986,1.5,8.424a1.477,1.477,0,0,1-1.525,1.766",
    transform: "translate(0 0.001)",
    fill: "#ebd000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "star-2",
    "data-name": "star",
    transform: "translate(245.553 753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2803-2",
    "data-name": "Group 2803",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10609-2",
    "data-name": "Path 10609",
    d: "M23.23,28.439a1.444,1.444,0,0,1-.684-.164l-7.634-4-7.636,4a1.5,1.5,0,0,1-2.168-1.59l1.5-8.424L.437,12.275a1.508,1.508,0,0,1-.374-1.5A1.5,1.5,0,0,1,1.28,9.764L9.808,8.522,13.568.843a1.491,1.491,0,0,1,2.686,0l3.807,7.663L28.59,9.75a1.474,1.474,0,0,1,.836,2.513l-6.167,5.986,1.5,8.424a1.477,1.477,0,0,1-1.525,1.766",
    transform: "translate(0 0.001)",
    fill: "#ebd000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "star-3",
    "data-name": "star",
    transform: "translate(289.038 753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2803-3",
    "data-name": "Group 2803",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10609-3",
    "data-name": "Path 10609",
    d: "M23.23,28.439a1.444,1.444,0,0,1-.684-.164l-7.634-4-7.636,4a1.5,1.5,0,0,1-2.168-1.59l1.5-8.424L.437,12.275a1.508,1.508,0,0,1-.374-1.5A1.5,1.5,0,0,1,1.28,9.764L9.808,8.522,13.568.843a1.491,1.491,0,0,1,2.686,0l3.807,7.663L28.59,9.75a1.474,1.474,0,0,1,.836,2.513l-6.167,5.986,1.5,8.424a1.477,1.477,0,0,1-1.525,1.766",
    transform: "translate(0 0.001)",
    fill: "#ebd000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "star-4",
    "data-name": "star",
    transform: "translate(331.671 753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2803-4",
    "data-name": "Group 2803",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10609-4",
    "data-name": "Path 10609",
    d: "M23.23,28.439a1.444,1.444,0,0,1-.684-.164l-7.634-4-7.636,4a1.5,1.5,0,0,1-2.168-1.59l1.5-8.424L.437,12.275a1.508,1.508,0,0,1-.374-1.5A1.5,1.5,0,0,1,1.28,9.764L9.808,8.522,13.568.843a1.491,1.491,0,0,1,2.686,0l3.807,7.663L28.59,9.75a1.474,1.474,0,0,1,.836,2.513l-6.167,5.986,1.5,8.424a1.477,1.477,0,0,1-1.525,1.766",
    transform: "translate(0 0.001)",
    fill: "#ebd000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "star-5",
    "data-name": "star",
    transform: "translate(375.156 753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2803-5",
    "data-name": "Group 2803",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10609-5",
    "data-name": "Path 10609",
    d: "M23.23,28.439a1.444,1.444,0,0,1-.684-.164l-7.634-4-7.636,4a1.5,1.5,0,0,1-2.168-1.59l1.5-8.424L.437,12.275a1.508,1.508,0,0,1-.374-1.5A1.5,1.5,0,0,1,1.28,9.764L9.808,8.522,13.568.843a1.491,1.491,0,0,1,2.686,0l3.807,7.663L28.59,9.75a1.474,1.474,0,0,1,.836,2.513l-6.167,5.986,1.5,8.424a1.477,1.477,0,0,1-1.525,1.766",
    transform: "translate(0 0.001)",
    fill: "#ebd000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarImg);
export default __webpack_public_path__ + "static/media/star-img.4795e219a210fea0e67f791d1041ae49.svg";
export { ForwardRef as ReactComponent };